function empty() {
  return [];
}

export default function (selector) {
  return selector == null ? empty : function () {
    return this.querySelectorAll(selector);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selectorAll.js
// module id = 394
// module chunks = 0